// export function convertOldToNewWorkflow(oldJson) {
//   const typeMap = {
//     sourceNode: "source",
//     destinationNode: "destination",
//     integrationNode: "integration", 
//     transformationNode: "transformation",
//     processorNode: "transformation",
//   };

//   const nodes = (oldJson.nodes || []).map((node) => ({
//     id: node.id,
//     type: typeMap[node.type] || node.type,
//     data: {
//       label: node.config?.label || "",
//       config: node.config || {},
//     },
//     position: node.position,
//   }));

//   const edges = (oldJson.edges || []).map((edge) => ({
//     source: edge.source,
//     target: edge.target,
//   }));

//   return { nodes, edges };
// }


export function convertOldToNewWorkflow(oldJson) {
  return {
    ...oldJson,
    nodes: (oldJson.nodes || []).map((node) => {
      if (
        node.data &&
        typeof node.data === "object" &&
        "label" in node.data &&
        "config" in node.data
      ) {
        return node;
      }

      return {
        ...node,
        data: {
          label: node.config.label || "",
          config: node.config || {},
        },
      };
    }),
  };
}

